import type { OnInit } from '@angular/core';
import { Component, ElementRef, forwardRef, Input, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import type { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import {
    BaseMultiSelectFormFieldComponent
} from '@shared/form-fields/multi-select/base-multi-select-form-field.component';
import type { AppSelectOption } from '@shared/form-fields/options/select-option';
import { ApiParams } from '@shared/http/api-params';
import type { Team } from '@shared/modules/teams/team';
import { TeamFetcher } from '@shared/modules/teams/team.fetcher';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-team-multi-select',
    styleUrls: ['./team-multi-select.component.scss'],
    templateUrl: '../../../form-fields/multi-select/multi-select-form-field.component.html',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TeamMultiSelectComponent), multi: true }],
})
export class TeamMultiSelectComponent extends BaseMultiSelectFormFieldComponent<Team> implements OnInit {
    @Input() params: ApiParams = {};
    @Input() showTriggerLabel = true;

    constructor(element: ElementRef,
                renderer: Renderer2,
                private fetcher: TeamFetcher) {
        super(element, renderer);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.fetch();
    }

    private fetch() {
        this.fetching = true;

        this.fetcher.all({
            ...this.params,
            order_by: 'description',
            direction: 'asc',
        }).pipe(
            finalize(() => this.fetching = false)
        ).subscribe(response => {
            this.apiOptions = [...response.data.map(team => ({
                label: team.description,
                value: team
            }))];
        });
    }

    onSelectionChange($event: MatSelectChange) {
        super.onSelectionChange($event);

        const value: AppSelectOption<Team>[] = $event.value;

        if (value.length === 0) {
            this.selectedOptions = [...this.options];
        }
    }

    get selectedOptionsLabel(): string {
        if (this.showTriggerLabel && this.allOptionsSelected) {
            return 'All Teams';
        }

        return super.selectedOptionsLabel;
    }

    get triggerLabel(): string {
        if (this.showTriggerLabel && this.allOptionsSelected) {
            return `<span class="badge badge-small badge-outline">All Teams Selected</span>`;
        }

        return null;
    }
}
